export const TitleBar = {
    title: "Danh sách đơn hàng gia công",
    addButtonText: "Tạo mới đơn hàng gia công",
};

export const TableColumns = [
    { text: "Mã yêu cầu", icon: <></> },
    { text: "Trạng thái", icon: <></> },
    { text: "Đơn vị gia công", icon: <></> },
    { text: "Ngày đến hàng", icon: <></> },
    { text: "Giá", icon: <></> },
    // { text: "Phụ trách", icon: <></> },
];

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Mã yêu cầu, Đơn vị gia công",
};

export const CreateOutsourceOrderTitleBar = {
    title: "Tạo mới đơn hàng gia công",
    addButtonText: "Tạo mới yêu cầu gia công",
};

export const WarningDiscardOutsourceOrder = {
    title: "Huỷ tạo đơn hàng",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const WarningCancelOutsourceOrder = {
    title: "Huỷ đơn hàng",
    context: [
        "Huỷ đơn hàng sẽ tạm dừng tất cả các hoạt động liên quan, bạn có chắc muốn huỷ bỏ không? " +
            "Hành động này sẽ không được hoàn tác.",
    ],
    reason: "Lý do hủy đơn hàng",
};

export const WarningDeclineOutsourceOrder = {
    title: "Từ chối duyệt đơn hàng",
    context: ["Bạn có chắc chắn muốn từ chối duyệt đơn hàng này không? Hành động này sẽ không được hoàn tác"],
    reason: "Lý do từ chối",
};

export const WarningDeclineReasonOutsourceOrder = {
    title: "Lý do đơn hàng vật tư bị từ chối",
};
